import classes from 'components/OrderInfo/OrderInfo.module.scss'
import PlaceHolderImage from 'assets/jpg/placeholder.jpg';
import Constants from 'config/constants';

export default function OrderInfo(props) {
	const OrderTile = (props) => {
		return (
			<div className={classes.OrderTileContainer}>
				<div className={classes.OrderTile}>
					<div className={classes.OrderImage}>
						<img src={props.orderItem.image ? `${props.orderItem.image}?qlt=70&wid=214&hei=214&fmt=jpeg` : PlaceHolderImage} alt={props.orderItem.description}/>
					</div>
					<div className={classes.OrderDescriptionContainer}>
						<div className={classes.OrderDescription}>
							<p className="body-medium-alt bold">{props.orderItem.description}</p>
						</div>
						{props.orderItem.definingAttributes.map(attribute => {
							return (
								<div className={classes.OrderAttributes}>
									<p className="body-medium-alt bold">{`${attribute.name}:\u00A0`}</p>
									<p className="body-medium-alt">{attribute.value}</p>
								</div>
							)
						})}
						<div className={classes.OrderAttributes}>
							<p className="body-medium-alt bold">{`Qty:\u00A0`}</p>
							<p className="body-medium-alt">{props.orderItem.orderedQty}</p>
						</div>
					</div>
				</div>
			</div>
		)
	};

	return (
		<div data-test-id="order-info-main">
			{props.multiStore ?
				<>
					{props.pickedUp ?
						<>
							{props.orderItems.map(store => {
								if (store.orderStatus === Constants.STATUS_PICKED_UP) {
									return (
										<>
											<div className={classes.Title}>
												<p className="body-small bold upper">At {store.name}</p>
											</div>
											{store.items.map(orderItem => {
												if (orderItem.itemStatus === Constants.STATUS_PICKED_UP) {
													return (
														<OrderTile orderItem={orderItem} />
													)
												} else {
													return null;
												}
											})}
										</>
									)
								} else {
									return null;
								}
							})}
						</>
						:
						<>
							{props.orderItems.map(store => {
								if (store.orderStatus === Constants.STATUS_READY) {
									return (
										<>
											<div className={classes.Title}>
												<p className="body-small bold upper">At {store.name}</p>
											</div>
											{store.items.map(orderItem => {
												if (orderItem.itemStatus === Constants.STATUS_READY) {
													return (
														<OrderTile orderItem={orderItem} />
													)
												} else {
													return null;
												}
											})}
										</>
									)
								} else {
									return null;
								}
							})}
						</>
					}
				</>
				:
				<>
					<div className={classes.Title}>
						<p className="body-small bold upper">{props.extend && !props.pickedUp ? 'Item Information' : 'Order Information'}</p>
					</div>
					{props.orderItems.map(orderItem => {
						return (
							<OrderTile orderItem={orderItem} />
						)
					})}
				</>
			}
		</div>
	);
}
